// extracted by mini-css-extract-plugin
export default {"title":"Waa-z","warning":"Xaa-z","sizeOptionsLegendText":"Yaa-z"};